// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"fd8e3c40","426":"2af6e282","961":"2734c010"}[chunkId] + ".chunk.css";
};